import React from 'react'

const Home = props => (
    <div>Home Page</div>
)

export default Home